import { FC } from 'react';

const ItWasGood: FC<{ filled?: boolean }> = ({ filled }) => {
    const color = filled ? '#00BC89' : '#BDBDBD';

    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1438_5178)">
                <path
                    d="M25 49.2789C11.6186 49.2789 0.721191 38.3815 0.721191 25.0001C0.721191 11.6187 11.6186 0.641113 25 0.641113C38.3815 0.641113 49.2789 11.5385 49.2789 24.92C49.2789 38.3014 38.3815 49.2789 25 49.2789ZM25 3.84624C13.3814 3.84624 3.84619 13.3815 3.84619 25.0001C3.84619 36.6187 13.3013 46.0738 24.9199 46.0738C36.5385 46.0738 45.9936 36.6187 45.9936 25.0001C45.9936 13.3815 36.6186 3.84624 25 3.84624Z"
                    fill={color}
                />
                <path
                    d="M25.4006 38.3813H24.9999C16.907 38.3813 13.2211 32.3717 12.4999 29.2467C12.2595 28.3653 12.8204 27.4839 13.7018 27.3237C14.5833 27.0833 15.4647 27.6442 15.6249 28.5256C15.705 28.766 17.4679 35.2563 25.08 35.2563H25.4807C33.0929 35.2563 34.8557 28.8461 34.9358 28.5256C35.1762 27.6442 36.0576 27.1634 36.8589 27.4038C37.7403 27.6442 38.2211 28.4454 38.0608 29.3269C37.0993 32.4519 33.4935 38.3813 25.4006 38.3813Z"
                    fill={color}
                />
                <path
                    d="M16.5865 23.077C18.1353 23.077 19.391 21.8214 19.391 20.2725C19.391 18.7236 18.1353 17.468 16.5865 17.468C15.0376 17.468 13.782 18.7236 13.782 20.2725C13.782 21.8214 15.0376 23.077 16.5865 23.077Z"
                    fill={color}
                />
                <path
                    d="M33.1731 23.077C34.722 23.077 35.9776 21.8214 35.9776 20.2725C35.9776 18.7236 34.722 17.468 33.1731 17.468C31.6243 17.468 30.3687 18.7236 30.3687 20.2725C30.3687 21.8214 31.6243 23.077 33.1731 23.077Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1438_5178">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ItWasGood;
